import { useEffect, useState } from 'react';
import Box from '@mui/material/Box';
import ImageNotSupportedOutlinedIcon from '@mui/icons-material/ImageNotSupportedOutlined';
import { alpha, useTheme } from '@mui/material/styles';

export function CardImage({
  src,
  alt,
  aspectRatio = '1 / 1',
  rounded = 2.5,
  iconSize = 32,
  fit = 'contain',
  inactive = false,
  padded = true,
  framed = true,
}) {
  const theme = useTheme();
  const isDark = theme.palette.mode === 'dark';
  const [failed, setFailed] = useState(false);
  const showImage = Boolean(src) && !failed;

  useEffect(() => {
    setFailed(false);
  }, [src]);

  return (
    <Box
      sx={{
        position: 'relative',
        width: '100%',
        aspectRatio,
        borderRadius: rounded,
        overflow: 'hidden',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        p: padded ? { xs: 1.25, sm: 1.5 } : 0,
        bgcolor: framed
          ? (isDark ? alpha('#D4A574', 0.08) : alpha('#B8894A', 0.06))
          : 'transparent',
        border: framed ? 1 : 0,
        borderColor: framed
          ? (isDark ? alpha('#D4A574', 0.18) : alpha('#B8894A', 0.14))
          : 'transparent',
        backgroundImage: framed
          ? (isDark
            ? 'linear-gradient(160deg, rgba(212,165,116,0.12) 0%, rgba(30,30,30,0.55) 55%, rgba(20,20,20,0.75) 100%)'
            : 'linear-gradient(160deg, rgba(255,249,240,0.95) 0%, rgba(247,239,227,0.9) 45%, rgba(240,212,168,0.22) 100%)')
          : 'none',
        boxShadow: framed
          ? (isDark
            ? 'inset 0 1px 0 rgba(255,255,255,0.04)'
            : 'inset 0 1px 0 rgba(255,255,255,0.7)')
          : 'none',
      }}
    >
      {showImage ? (
        <Box
          component="img"
          src={src}
          alt={alt}
          loading="lazy"
          decoding="async"
          onError={() => setFailed(true)}
          sx={{
            width: '100%',
            height: '100%',
            objectFit: fit,
            objectPosition: 'center',
            display: 'block',
            transition: 'transform 0.28s ease',
            filter: inactive ? 'grayscale(0.65) opacity(0.55)' : 'none',
            '.MuiCard-root:hover &': inactive ? undefined : { transform: 'scale(1.04)' },
          }}
        />
      ) : (
        <ImageNotSupportedOutlinedIcon
          sx={{ color: 'primary.main', opacity: 0.4, fontSize: iconSize }}
          aria-hidden
        />
      )}
    </Box>
  );
}
